import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_xbD2yvDTb9Zf: {
	id: 'prd_xbD2y2DEV2vDTb9Zf'
	ident: 'prd_xbD2yvDTb9Zf'
	sku: 'simple_premium_1w_6_19_4w_52_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_uISkc2DEV226ywd9G'
			amount: 26
			amount_usd: 6.19
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 6.19
			discount: 19.81
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_rQGLa2DEV21jEBAZB'
			amount: 52
			amount_usd: 52
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_xbD2yvDTb9Zf, SubscriptionProduct>
const prd_xbD2yvDTb9Zf = { ident: 'prd_xbD2yvDTb9Zf' } as typeof _prd_xbD2yvDTb9Zf

export default prd_xbD2yvDTb9Zf
